import React, { Fragment } from 'react';
import { Search, ArrowRight, RefreshCcw, Flame } from 'lucide-react';
export const Mechanism: React.FC = () => {
  const steps = [{
    num: '01',
    title: 'Identificás el disparador biológico',
    icon: <Search size={32} className="text-terracotta" data-id="element-179" />
  }, {
    num: '02',
    title: 'Lo reemplazás por una opción local rica',
    icon: <RefreshCcw size={32} className="text-terracotta" data-id="element-180" />
  }, {
    num: '03',
    title: 'Apagás el ardor',
    icon: <Flame size={32} className="text-terracotta" data-id="element-181" />
  }];
  return <section className="py-16 md:py-24 px-4 max-w-5xl mx-auto" data-id="element-182">
      <div className="text-center mb-16" data-id="element-183">
        <h2 className="font-serif text-3xl md:text-4xl text-earth font-bold mb-4" data-id="element-184">
          No es una dieta. Es el Método de Sustitución Proactiva.
        </h2>
      </div>

      <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-4 mb-12" data-id="element-185">
        {steps.map((step, index) => <Fragment key={index} data-id="element-186">
            <div className="flex flex-col items-center text-center max-w-[250px]" data-id="element-187">
              <div className="w-20 h-20 bg-cream-card rounded-full flex items-center justify-center mb-6 relative shadow-sm border border-terracotta/10" data-id="element-188">
                <span className="absolute -top-2 -left-2 bg-sage text-white text-xs font-bold w-8 h-8 rounded-full flex items-center justify-center border-2 border-cream" data-id="element-189">
                  {step.num}
                </span>
                {step.icon}
              </div>
              <p className="font-sans font-medium text-earth text-lg leading-snug" data-id="element-190">
                {step.title}
              </p>
            </div>

            {index < steps.length - 1 && <div className="hidden md:block text-terracotta/30" data-id="element-191">
                <ArrowRight size={32} data-id="element-192" />
              </div>}

            {index < steps.length - 1 && <div className="md:hidden w-px h-8 bg-terracotta/20" data-id="element-193"></div>}
          </Fragment>)}
      </div>

      <div className="text-center bg-sage/10 rounded-xl p-6 max-w-3xl mx-auto" data-id="element-194">
        <p className="font-sans text-earth-light text-sm md:text-base" data-id="element-195">
          Basado en la biología de la progesterona y la presión mecánica del
          útero, no en consejos de internet.
        </p>
      </div>
    </section>;
};